import { ssrTrack } from '@/lib/actions/analytics/ssr-track';
import { openFlexCustomerModalAtom } from '@/ui/atoms/form-atoms';
import { useClearInputs } from '@/ui/hooks/useClearInputs';
import { useResetInputs } from '@/ui/hooks/useResetInputs';
import { Modal } from '@mantine/core';
import { useAtom } from 'jotai';
import styles from './FlexCustomerModal.module.css';

export const FlexCustomerModal: React.FC = () => {
    const [openFlexCustomerModal, setOpenFlexCustomerModal] = useAtom(
        openFlexCustomerModalAtom
    );

    const resetInputs = useResetInputs();
    const { clearAll } = useClearInputs();

    return (
        <Modal
            opened={openFlexCustomerModal}
            onClose={() => {
                setOpenFlexCustomerModal(false);
                ssrTrack('flexCustomerModalClickOutside');
            }}
            centered
            withCloseButton={false}
            radius={8}
            size="auto"
            className={styles.modalBody}
        >
            <div className={styles.wrapper}>
                <h2 className={styles.title}>
                    You are a great candidate for Sunrun Flex, a new solar and
                    storage plan that grows with you.
                </h2>

                <div className={styles.buttons}>
                    <button
                        className={styles.restartButton}
                        onClick={() => {
                            ssrTrack('flexCustomerModalClickRestart');
                            setOpenFlexCustomerModal(false);
                            resetInputs();
                        }}
                    >
                        Restart
                    </button>
                    <button
                        className={styles.closeButton}
                        onClick={() => {
                            ssrTrack('flexCustomerModalClickClose');
                            setOpenFlexCustomerModal(false);
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};
